import { Document } from '@tiptap/extension-document'

export default Document.extend({})
